"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobSelection = exports.SelectStatesEnum = exports.SelectActionsEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const job_product_1 = require("./job_product");
const custom_services_1 = require("./custom-services");
const job_service_1 = require("./job-service");
const job_1 = require("./job");
var SelectActionsEnum;
(function (SelectActionsEnum) {
    SelectActionsEnum["PARTIAL_INVOICING"] = "PARTIAL_INVOICING";
})(SelectActionsEnum = exports.SelectActionsEnum || (exports.SelectActionsEnum = {}));
var SelectStatesEnum;
(function (SelectStatesEnum) {
    SelectStatesEnum["INVOICED"] = "invoiced";
    SelectStatesEnum["SCHEDULED"] = "scheduled";
})(SelectStatesEnum = exports.SelectStatesEnum || (exports.SelectStatesEnum = {}));
let JobSelection = class JobSelection {
};
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], JobSelection.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => job_product_1.JobProduct, (product) => product.selections),
    __metadata("design:type", job_product_1.JobProduct)
], JobSelection.prototype, "product", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => job_service_1.JobService, (service) => service.selections),
    __metadata("design:type", job_service_1.JobService)
], JobSelection.prototype, "service", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => custom_services_1.CustomService, (c_service) => c_service.selections),
    __metadata("design:type", custom_services_1.CustomService)
], JobSelection.prototype, "c_service", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
    }),
    __metadata("design:type", Boolean)
], JobSelection.prototype, "selected", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(SelectStatesEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: SelectStatesEnum,
        nullable: true,
        default: null,
    }),
    __metadata("design:type", String)
], JobSelection.prototype, "state", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(SelectActionsEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: SelectActionsEnum,
        nullable: true,
        default: null,
    }),
    __metadata("design:type", String)
], JobSelection.prototype, "action", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => job_1.Job, (job) => job.products),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], JobSelection.prototype, "job", void 0);
JobSelection = __decorate([
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('job_selection', { schema: 'public' })
], JobSelection);
exports.JobSelection = JobSelection;
//# sourceMappingURL=job-selection.js.map